<template>
  <div class="my-3">
    <div class="row">
      <div class="col timeline-overflow">
        <div class="timeline-steps aos-init aos-animate" data-aos="fade-up">
          <!-- step 1 -->
          <div
            v-for="(step, idx) in steps"
            :key="step['order']"
            :class="stepChoice(step['status'])"
          >
            <div class="timeline-content">
              <div :class="background(idx)">
                <b-button
                  :id="'step_' + (idx + 1)"
                  :style="circleStyle(step['status'], idx)"
                  class="inner-circle"
                ></b-button>
              </div>
              <div :style="titleColor(step['status'])" class="titleStyle">
                {{ step['title'] }}
              </div>
              <div v-if="noDatesAvailableCheck(step)" class="dateStyle mt-2">
                Date Not Available
              </div>
              <div v-else>
                <p v-if="!dateTypeStyle(step)" class="dateStyle">
                  {{ calcDateType(step['status'], step['actualDate']) }}
                </p>
                <p v-else class="dateStyle">Planned Date</p>
                <p class="dateStyle">{{ calcDate(step) }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-popover
      v-if="!isSummaryPage"
      custom-class="custom-body-class"
      placement="bottom"
      target="step_5"
      triggers="click"
    >
      <b-icon
        class="float-right"
        icon="x"
        scale="1.3"
        style="color: #0064c1; cursor: pointer"
        @click="$root.$emit('bv::hide::popover', 'step_5')"
      ></b-icon>
      <div class="popoverTitle">
        <b-icon
          :icon="titleIcon(itemWithSubSteps['status'])"
          class="mr-1"
          style="color: #0064c1"
        ></b-icon>
        {{ itemWithSubSteps['title'] }}
      </div>
      <p class="dateStyle px-2">
        {{ calcDateType(itemWithSubSteps['status'], itemWithSubSteps['status']) }}
      </p>
      <p class="dateStyle px-2">{{ calcDate(itemWithSubSteps) }}</p>
      <b-row v-if="itemWithSubSteps['subSteps'].length > 0" class="p-0 px-2">
        <b-col cols="10">
          <b-progress
            :max="itemWithSubSteps['subSteps'].length + 1"
            :value="calculateProgress(itemWithSubSteps)"
            class="mt-3"
            height="0.5rem"
          ></b-progress>
        </b-col>
        <b-col cols="2">
          <b-button
            v-b-toggle="'accordion_5'"
            bg-white
            class="float-right shadow-none"
            style="border: none"
            variant="white"
            @click.prevent
            ><span class="when-open"><b-icon font-scale="0.8" icon="chevron-up"></b-icon></span
            ><span class="when-closed"><b-icon font-scale="0.8" icon="chevron-down"></b-icon></span>
          </b-button>
        </b-col>
      </b-row>
      <b-collapse id="accordion_5" style="background: #fbfbfb">
        <hr v-if="itemWithSubSteps['subSteps'].length > 0" class="solid m-0 p-0" />
        <vertical-stepper :subSteps="itemWithSubSteps['subSteps']"></vertical-stepper>
      </b-collapse>
    </b-popover>
  </div>
</template>

<script>
  import moment from 'moment';
  import VerticalStepper from './VerticalStepper';

  export default {
    components: {
      VerticalStepper,
    },
    props: {
      steps: Array,
      isSummaryPage: Boolean,
    },
    data() {
      return {
        id: '',
        popoverId: '',
        itemWithSubSteps: null,
      };
    },
    created() {
      this.itemWithSubSteps = this.steps[4];
    },
    mounted() {
      let foundIndex = this.steps.findIndex(element => element['status'] === 'InProgress');
      this.id = 'step_' + (foundIndex + 1);
      if (foundIndex > -1) {
        document.getElementById(this.id).focus();
      }
    },
    methods: {
      noDatesAvailableCheck(step) {
        const isCompletedWithoutActualDate = step['status'] === 'Completed' && !step['actualDate'];
        const isUnplannedWithoutActualDate = !step['plannedDate'] && !step['actualDate'];

        return isCompletedWithoutActualDate || isUnplannedWithoutActualDate;
      },
      background(idx) {
        let classes = 'mb-3 stepBackground';
        if (idx === 0) {
          return `${classes} borderLeft`;
        }
        if (idx === this.steps.length - 1) {
          return `${classes} borderRight`;
        }
        return `${classes}`;
      },
      calculateProgress(step) {
        let count = 0;
        step['subSteps'].forEach(el => {
          if (el['status'] === 'Completed') {
            count++;
          }
        });
        if (step['status'] === 'Completed') {
          count++;
        }
        return count;
      },
      titleColor(status) {
        return status !== 'Untouched' ? 'color: #383838;' : 'color: #6f6f6f;';
      },
      stepChoice(status) {
        return status === 'Untouched' ? 'timeline-step-white' : 'timeline-step';
      },
      circleStyle(status, idx) {
        let style = '';
        if (status === 'Untouched') {
          style = 'background-color:#FFFFFF; border: 5px solid #ADAAB5;';
        } else if (status === 'InProgress') {
          style = 'background-color:#FFFFFF; border: 5px solid #7f7fe4;';
        }
        if (idx !== 4) {
          style += 'pointer-events: none;';
        }

        return style;
      },
      titleIcon(status) {
        if (status === 'Untouched') {
          return 'hourglass';
        } else if (status === 'InProgress') {
          return 'hourglass-split';
        } else {
          return 'check';
        }
      },
      showInStart(status) {
        return status === 'InProgress';
      },
      onOpen(idx) {
        this.$root.$emit('bv::hide::popover', this.id);
        this.id = 'step_' + (idx + 1);
        this.$root.$emit('bv::show::popover', this.id);
      },
      dateTypeStyle(step) {
        return step['status'] === 'Completed' && !step['actualDate'] && !step['plannedDate'];
      },
      calcDateType(status, actualDate) {
        let dateValue = actualDate ? moment(actualDate).format('DD MMM YYYY') : 'Not Available';
        return status === 'Completed' && dateValue !== 'Not Available'
          ? 'Actual Date'
          : 'Planned Date';
      },
      calcDate(step) {
        if (step['status'] === 'Completed') {
          if (step['actualDate']) {
            return moment(step['actualDate']).format('DD MMM YYYY');
          } else if (step['plannedDate']) {
            return moment(step['plannedDate']).format('DD MMM YYYY');
          } else {
            return 'Not Available';
          }
        } else {
          return step['plannedDate']
            ? moment(step['plannedDate']).format('DD MMM YYYY')
            : 'Not Available';
        }
      },
      formatDate(date) {
        if (date === null || date === '') {
          return '';
        } else {
          return moment(date).format('DD MMM YYYY');
        }
      },
    },
  };
</script>

<style scoped>
  .timeline-steps {
    display: flex;
    justify-content: center;
    /* flex-wrap: wrap; */
  }

  .timeline-step {
    align-items: center;
    display: flex;
    flex-direction: column;
    position: relative;
  }

  .timeline-step:not(:last-child):after {
    content: '';
    display: block;
    border-top: 0.25rem solid #7f7fe4;
    width: 4.1rem;
    position: absolute;
    left: 6rem;
    top: 1.9rem;
  }

  .timeline-step:not(:first-child):before {
    content: '';
    display: block;
    border-top: 0.25rem solid #7f7fe4;
    width: 4.1rem;
    position: absolute;
    right: 6rem;
    top: 1.9rem;
  }

  .timeline-step-white {
    align-items: center;
    display: flex;
    flex-direction: column;
    position: relative;
  }

  .timeline-step-white:not(:last-child):after {
    content: '';
    display: block;
    border-top: 0.25rem solid #adaab5;
    width: 4.1rem;
    position: absolute;
    left: 6rem;
    top: 1.9rem;
  }

  .timeline-step-white:not(:first-child):before {
    content: '';
    display: block;
    border-top: 0.25rem solid #adaab5;
    width: 4.1rem;
    position: absolute;
    right: 6rem;
    top: 1.9rem;
  }

  .timeline-content {
    width: 10rem;
    text-align: center;
  }

  @media (max-width: 1300px) {
    .timeline-content {
      width: 7rem;
      text-align: center;
    }

    .timeline-step:not(:last-child):after {
      content: '';
      display: block;
      border-top: 0.25rem solid #7f7fe4;
      width: 2.8rem;
      position: absolute;
      left: 4rem;
      top: 1.9rem;
      margin-left: 5px;
    }

    .timeline-step:not(:first-child):before {
      content: '';
      display: block;
      border-top: 0.25rem solid #7f7fe4;
      width: 2.7rem;
      position: absolute;
      right: 4rem;
      top: 1.9rem;
      margin-right: 5px;
    }

    .timeline-step-white:not(:last-child):after {
      content: '';
      display: block;
      border-top: 0.25rem solid #adaab5;
      width: 2.8rem;
      position: absolute;
      left: 4rem;
      top: 1.9rem;
      margin-left: 5px;
    }

    .timeline-step-white:not(:first-child):before {
      content: '';
      display: block;
      border-top: 0.25rem solid #adaab5;
      width: 2.7rem;
      position: absolute;
      right: 4rem;
      top: 1.9rem;
      margin-right: 5px;
    }
  }

  @media (max-width: 895px) {
    .timeline-overflow {
      overflow-x: auto;
      display: flex;
      padding-inline: 1.5rem;
      padding-bottom: 2rem;
    }
  }

  .inner-circle {
    border-radius: 1.5rem;
    height: 2rem;
    width: 2rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: #7f7fe4;
  }

  .titleStyle {
    font-weight: 600;
    font-size: 12px;
    line-height: 15px;
    text-align: center;
    letter-spacing: 0.25px;
    height: 3rem;
  }

  .dateStyle {
    font-weight: 400;
    font-size: 11px;
    line-height: 16px;
    text-align: center;
    letter-spacing: 0.25px;
    color: #6f6f6f;
    margin-bottom: 0px;
  }

  .popoverTitle {
    font-weight: 600;
    font-size: 13px;
    line-height: 19px;
    letter-spacing: 0.25px;
    color: #0064c1;
    text-align: center;
    margin-bottom: 0.5rem;
    padding-inline: 1.5rem;
  }

  .popoverDate {
    font-weight: 400;
    font-size: 11px;
    line-height: 16px;
    letter-spacing: 0.25px;
    color: #6f6f6f;
  }

  .custom-body-class .popover-body {
    padding-inline: 0;
    width: 15rem;
  }

  .stepBackground {
    background-color: white;
    height: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .borderLeft {
    border-radius: 96px 0px 0px 96px;
  }

  .borderRight {
    border-radius: 0px 96px 96px 0px;
  }
</style>
